import { h } from 'preact';

const MaxOrderMessage = ({ maxOrder, errorMessage, quantity }) =>
  quantity >= maxOrder && (
    <p className="text-body-2 text-red mb-1.5 mt-2.5">{errorMessage}</p>
  );

export default MaxOrderMessage;
